<template>
	<div class="friend-request" ref="reqTabs">
		<el-tabs>
			<el-tab-pane :label="'收到的申请(' + recvRequests.length + ')'">
				<el-scrollbar v-if="recvRequests.length" class="request-list" :style="tabPaneStyle">
					<div class="request-item" v-for="request in recvRequests" :key="request.id">
						<friend-request-item :request="request"></friend-request-item>
					</div>
				</el-scrollbar>
				<no-data-tip v-else class="no-data-tip" :style="tabPaneStyle"></no-data-tip>
			</el-tab-pane>
			<el-tab-pane :label="'发起的申请(' + sendRequests.length + ')'">
				<el-scrollbar v-if="sendRequests.length" class="request-list" :style="tabPaneStyle">
					<div class="request-item" v-for="request in sendRequests" :key="request.id">
						<friend-request-item :request="request"></friend-request-item>
					</div>
				</el-scrollbar>
				<no-data-tip v-else class="no-data-tip" :style="tabPaneStyle"></no-data-tip>
			</el-tab-pane>
		</el-tabs>
	</div>
</template>

<script>
import NoDataTip from '../common/NoDataTip.vue'
import FriendRequestItem from './FriendRequestItem.vue'

export default {
	name: "friendRequest",
	components: { NoDataTip, FriendRequestItem },
	data() {
		return {
			tabPaneHeight: 600
		}
	},
	computed: {
		mine() {
			return this.userStore.userInfo;
		},
		recvRequests() {
			let requests = this.friendStore.requests;
			return requests.filter((req) => req.recvId == this.mine.id);
		},
		sendRequests() {
			let requests = this.friendStore.requests;
			return requests.filter((req) => req.sendId == this.mine.id);
		},
		tabPaneStyle() {
			return `height:${this.tabPaneHeight}px`;
		}
	},
	mounted() {
		this.updateTabPaneHeight();
		window.addEventListener('resize', this.updateTabPaneHeight);
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.updateTabPaneHeight);
	},
	methods: {
		updateTabPaneHeight() {
			const container = this.$refs.reqTabs;
			if (!container) {
				return;
			}
			this.tabPaneHeight = Math.max(container.offsetHeight - 74, 220);
		}
	}
}
</script>

<style scoped lang="scss">
.friend-request {
	display: flex;
	flex-direction: column;
	height: 100%;
	background: var(--im-chat-bg);

	.tabs {
		flex: 1;
	}

	:deep(.el-tabs) {
		height: 100%;
		display: flex;
		flex-direction: column;
	}

	:deep(.el-tabs__header) {
		margin: 0;
		padding: 0 16px;
		border-bottom: 1px solid rgba(var(--im-black-rgb), 0.08);
		background: var(--im-chat-bg);
	}

	:deep(.el-tabs__nav-wrap::after) {
		display: none;
	}

	:deep(.el-tabs__item) {
		height: 48px;
		line-height: 48px;
		padding: 0 4px;
		font-size: 13px;
		color: var(--im-text-color-light);
	}

	:deep(.el-tabs__item.is-active) {
		color: var(--im-color-primary);
		font-weight: 600;
	}

	:deep(.el-tabs__content) {
		flex: 1;
		min-height: 0;
	}

	:deep(.el-tab-pane) {
		height: 100%;
	}

	:deep(.el-scrollbar__view) {
		display: flex;
		flex-direction: column;
		align-items: stretch;
		width: 100%;
		text-align: left;
	}

	.request-list,
	.no-data-tip {
		padding: 8px 16px 14px;
		box-sizing: border-box;
	}

	.request-item {
		width: 100%;
		text-align: left;
	}
}
</style>
